import { __rest } from "tslib";
import * as React from "react";
function SvgChevronLeft(_a) {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2048 2048", width: "1em", height: "1em", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M1533 93l-930 931 930 931-90 90L421 1024 1443 3l90 90z" })));
}
export default SvgChevronLeft;
